export default "__VITE_ASSET__42cca459__"